import axios from 'axios';

import * as utils from '../utils/utils.js';

export const signup = async (name, email, password) => {
    const server_url = utils.backendUrl() + `/signup`;

    try {
        const response = await axios.post(server_url, {
            name: name,
            email: email,
            password: password,
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response;
    } catch (err) {
        console.log(err.message);
        if (err.response.status === 409) {
            return err.response;
        }
        console.log('error', err.message);
        console.log(err.response);
    }
};

export const passwordRequestReset = async (email) => {
    const server_url = utils.backendUrl() + `/password-reset`;

    try {
        const response = await axios.post(server_url, {
            email: email,
            headers: {
                'Content-Type': 'application/json',
            },
        });
        console.log('response', response);
        return response;
    } catch (err) {
        console.log(err.message);
        console.log(err.response);
    }
};

export const passwordReset = async (password, token) => {
    const server_url = utils.backendUrl() + `/confirm-password-reset`;

    try {
        const response = await axios.post(server_url, {
            password: password,
            token: token,
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response;
    } catch (err) {
        console.log(err.message);
        console.log(err.response);
    }
};

export const changePassword = async (currentPassword, newPassword) => {
    const server_url = utils.backendUrl() + `/change-password`;

    try {
        const response = await axios.post(
            server_url,
            {
                currentPassword: currentPassword,
                newPassword: newPassword,
            },
            {
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );
        return response;
    } catch (err) {
        throw err;
    }
};

export const updateProfile = async (name, email) => {
    const server_url = utils.backendUrl() + `/update-profile`;

    try {
        const response = await axios.patch(
            server_url,
            {
                name: name,
                email: email,
            },
            {
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );
        return response;
    } catch (err) {
        throw err;
    }
};
